export enum MobileOS {
  IOS = 'iOS',
  ANDROID = 'Android',
  WINDOWS = 'Windows',
  LINUX = 'Linux',
  MACINTEL = 'MacIntel',
  UNKNOWN = 'Unknown',
}

export enum Browser {
  SAFARI = 'Safari',
  CHROME = 'Chrome',
  FIREFOX = 'Firefox',
  EDGE = 'Edge',
  IE = 'Internet Explorer',
  UNKNOWN = 'Unknown',
}
